//#region src/druid/druid.ts
const DRUID_AGGREGATE_NAME = "metric";
let DataSourceType = /* @__PURE__ */ function(DataSourceType) {
	DataSourceType["ApiLogs"] = "apiLogs";
	DataSourceType["ApiDW"] = "apiDW";
	DataSourceType["ApiSubscriptionLogs"] = "apiSubscriptionLogs";
	DataSourceType["ApiSubscriptionDW"] = "apiSubscriptionDW";
	DataSourceType["ApiWalletServerEvents"] = "apiWalletServerEvents";
	/** Slim MINUTE-grain throughput rollup (`dx-throughput`). */
	DataSourceType["DxThroughput"] = "dxThroughput";
	/** Slim HOUR-grain usage rollup (`dx-usage`). */
	DataSourceType["DxUsage"] = "dxUsage";
	return DataSourceType;
}({});
let Period = /* @__PURE__ */ function(Period) {
	Period["Minute_5"] = "Minute_5";
	Period["Hour_1"] = "Hour_1";
	Period["Hour_24"] = "Hour_24";
	Period["Day_7"] = "Day_7";
	Period["Day_30"] = "Day_30";
	return Period;
}({});
//#endregion
export { DRUID_AGGREGATE_NAME, DataSourceType, Period };

//# sourceMappingURL=druid.js.map